import * as React from "react";
import { Icon } from "sb-resp-ui";
export class Name extends React.Component {
    render() {
        return (React.createElement("div", { className: "rj-racing-next-races__game" },
            React.createElement("span", { className: "rj-racing-next-races__game-title" }, this.props.title),
            this.props.hasLiveStream && (React.createElement(Icon, { i: "i-24-16 i-o-ev-alt-streaming" }))));
    }
}
//# sourceMappingURL=Name.js.map